export enum FileTypes {
  csv = 'csv',
  xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xls = 'xls',
  jpg = 'jpg',
  jpeg = 'jpeg',
  png = 'png',
  heic = 'heic',
}

export enum MaxSizeFileMB {
  image = 5,
  excelFile = 1,
}
